import React from 'react';

// Styles & Assets
import styles from './RowButtonsFilter.module.css';

// Languages
import MultiSelectButtons from '../../Helpers/MultiSelectButtons/MultiSelectButtons';

// RowFilterDialog: Wrapper of a row in the FilterDialog component. Props:
//  -text: title of the row
//  -children: elements inside the row.
const RowButtonsFilter: React.FC<{
    text: string,
    currentFilters: number[],
    setFilters?: React.Dispatch<React.SetStateAction<number[]>>,
    handleClick?: (id: number) => void,
    content: { id: number, content: JSX.Element | string }[],
    gridDisplay?: true,
}> = ({ text, setFilters, currentFilters, handleClick, content, gridDisplay }) => {

    const onClick = (id: number) => {
        if (handleClick) handleClick(id);
        if (setFilters) setFilters(oldFilters => {
            const newFilters = [...oldFilters];
            return newFilters.some(filterID => filterID === id) ?
                newFilters.filter(filterID => filterID !== id)
                :
                [...newFilters, id];
        });
    };

    return (
        <div className={styles.filterContainer}>
            <p className={styles.label}>{text}</p>
            <MultiSelectButtons 
                content={content}
                selectedIDs={currentFilters}
                onClick={onClick}
                gridDisplay={gridDisplay}
            />
        </div>
    );
};
export default RowButtonsFilter;